<h2 mat-dialog-title>
    @if(showSpinner()) {
    Preparing...
    } @else {
    Actions
    }
</h2>
<mat-dialog-content>
    @if(!showSpinner()) {
    <p>
        What would you like to do?
    </p>
    <br />
    }

    @if (showSpinner()) {
    <p>
        One moment while we prepare the document for you.
    </p>
    <div style="display: flex; justify-content: center;">
        <mat-spinner></mat-spinner>
    </div>
    }

</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close color="warn" [disabled]="disabled()">Cancel</button>
    <button mat-button (click)="onDownload()" [disabled]="disabled()">Download</button>
    <button mat-button color="primary" cdkFocusInitial (click)="onView()" [disabled]="disabled()">View</button>
    <button mat-button (click)="onPrint()" [disabled]="disabled()">Print</button>
    <button mat-button color="primary" (click)="onEmail()" [disabled]="disabled()">Email</button>
</mat-dialog-actions>